import { render, staticRenderFns } from "./NewsTags.vue?vue&type=template&id=418b058a&"
import script from "./NewsTags.vue?vue&type=script&lang=js&"
export * from "./NewsTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports